// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

import DataTable from "components/Tables/DevicesTable";

import {
    QueryClient,
    QueryClientProvider,
    useQuery,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import bksAPI from 'services/api/bks';
import userAPI from 'services/api/user';
import { calculateBattery, processDevicesData } from "utils/device";
import { getUserAccessLevel } from "utils/setup";

import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

import PropTypes from 'prop-types';
import { useEffect } from "react";
import { Box, CircularProgress, Container, Grid, Tooltip } from "@mui/material";
import moment from "moment";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import UptimeDoughnutChart from "components/Charts/StatisticCards/UptimeDoughnutChart";

import { wrapper, loadingScreen } from "utils/wrapper";
import { disableMap } from "utils/map";
import CreateInspection from "pages/components/Operations/CreateInspection";
import { useSoftUIController } from "hooks/context";

function NewInspectionView({ map, user }) {
    disableMap(map);

    // Queries
    bksAPI.loadToken(useAuth0());
    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    const navigate = useNavigate();
    const location = useLocation();

    const { device } = location.state || {};

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        },
        // staleTime: 30 * 1000
    });

    if (devices.isLoading) {
        return loadingScreen(deviceLayout, true);
    }

    if (devices.error) {
        // console.error(error);
        var error = devices.error;
        return wrapper((
            <SoftBox p={3} lineHeight={1}>
                <SoftTypography variant="h5" fontWeight="medium">
                    {"An error has occurred: " + error.message}
                </SoftTypography>
            </SoftBox>
        ), deviceLayout, true
        );
    }

    const devices_data = processDevicesData(devices.data, true);
    var device_data = false;
    if (typeof device != 'undefined') {
        device_data = processDevicesData([device]);
    }

    return (
        wrapper((
            <Box display="flex" justifyContent="center">
                <SoftBox sx={{ width: "100%", maxWidth: "1400px" }}>
                    <CreateInspection selected_user={user} all_devices={devices_data} selected_device={device} />
                </SoftBox>
            </Box>
        ), deviceLayout, true
        )
    );
}

NewInspectionView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default NewInspectionView;
